import { action } from "typesafe-actions";

export const RESET_APP_STATE = "RESET_APP_STATE" as const;

export const resetAppState = () => action(RESET_APP_STATE);
